module.exports = __webpack_public_path__ + "img/5-2.39a2c9be.svg";